<template>
  <div class="v-healthy-nutrition">
    <div class="d-flex justify-space-between">
      <h2 class="mb-8">{{ $ucfirst($t("screens.healthyNutritionSettingsScreen", { catalog: 'app_mobile' })) }}</h2>
      <level-of-guidance-indicator behaviourComponent="HEALTHYNUTRITION"></level-of-guidance-indicator>
    </div>
    <h-n-button-line />
    <router-view></router-view>
    <discussion-step-nav-buttons
      :nextRoutes="nextDiscussionStep"
      :prevRoutes="prevDiscussionStep"
    >
    </discussion-step-nav-buttons>
  </div>
</template>

<script>
import DiscussionStepNavButtons from '../../../components/Parts/DiscussionStepNavButtons.vue';
import LevelOfGuidanceIndicator from "../../../components/Parts/LevelOfGuidanceIndicator.vue";
import HNButtonLine from '../../../components/Parts/HNButtonLine';

export default {
  name: 'PatientOverviewHN',
  props: ['nextDiscussionStep', 'prevDiscussionStep'],
  components: {
    HNButtonLine,
    LevelOfGuidanceIndicator,
    DiscussionStepNavButtons
  }
}
</script>
